'use client';

import { Suspense } from 'react';
import { OrderListTable } from '@/widgets/order/order-list-table';
import { Box, IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { SearchIcon } from '@/shared/ui/display/EmojiIcon';
import { TabPageComponent } from '@/entities/tab/model/tab.types';
import { TabContext } from '@/entities/tab/model/tab.types';
import { TabToolbar } from '@/widgets/tab/tab-toolbar';
import { MobilePageHeader } from '@/shared/ui/mobile/MobilePageHeader';

export const OrderListPage: TabPageComponent = function OrderListPage(props: TabContext) {
  const params = props.params ?? {};
  const size = (params as { size?: number }).size ?? 20;
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleRowClick = (order: unknown) => {
    console.log('Order clicked:', order);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <TabToolbar tabId={props.tabId || ''} />
      {isMobile && (
        <MobilePageHeader
          title="주문 목록"
          rightActions={
            <Tooltip title="검색">
              <IconButton size="small" aria-label="검색">
                <SearchIcon />
              </IconButton>
            </Tooltip>
          }
        />
      )}
      <Box sx={{ flex: 1, overflow: 'auto', pb: isMobile ? 0 : 0 }}>
        <Suspense fallback={null}>
          <OrderListTable pageSize={size} onRowClick={handleRowClick} tabContext={props} />
        </Suspense>
      </Box>
    </Box>
  );
};

export default OrderListPage;
